/*
Example state:

export default {
  byId: {
    party1: {
      id: 'party1',
      name: 'customer',
    },
    party2: {
      id: 'party2',
      name: 'agent'
    },
  },
  allIds: ['msg1', 'msg2'],
};

*/

export default {
  byId: {},
  allIds: [],
};
